export default __webpack_public_path__ + "static/media/sprite_footer_02.5384e02f.png";